import { axios } from '@Api/axiosClient';
import type { DashboardResponse, DealDashboard, TaskNavigationResult } from '@Types/dashboard.types';

const baseUrl = 'api/Dashboard';

export const getTaskViewApi = async (): Promise<DashboardResponse> => {
    const response = await axios.get(`${baseUrl}/GetTaskView`);
    return response?.data ?? { deals: [], summary: {} };
};

export const getDealTasksApi = async (dealId: string): Promise<DealDashboard> => {
    const response = await axios.get(`${baseUrl}/GetDealTasks`, {
        params: { dealId },
    });
    return response?.data ?? {};
};

export const logoutApi = async (): Promise<void> => {
    await axios.post(`${baseUrl}/Logout`);
};

export const prepareTaskNavigationApi = async (taskId: string, dealId: string): Promise<TaskNavigationResult> => {
    const response = await axios.post(`${baseUrl}/PrepareTaskNavigation`, { taskId, dealId });
    return response.data;
};

export interface ParticipantPaymentNavigationResult {
    // Optional because the caller guards on it: a BFF that does not serve this
    // endpoint answers without a path rather than with an empty one.
    path?: string | null;
}

export const startParticipantInitiatedPaymentApi = async (
    dealId: string,
    purpose: string,
): Promise<ParticipantPaymentNavigationResult> => {
    const response = await axios.post(`${baseUrl}/StartParticipantInitiatedPayment`, { dealId, purpose });
    return response.data;
};

export const startTaskApi = async (taskId: string): Promise<void> => {
    await axios.post(`${baseUrl}/StartTask`, { taskId });
};

export const completeTaskApi = async (taskId: string): Promise<void> => {
    await axios.post(`${baseUrl}/CompleteTask`, { taskId });
};

export interface RcsConsentResponse {
    participantId: string;
    rcsConsent: boolean;
    rcsConsentAt: string;
}

export const captureRcsConsentApi = async (
    participantId: string,
    rcsConsent: boolean,
): Promise<RcsConsentResponse> => {
    const response = await axios.post(`${baseUrl}/CaptureRcsConsent`, { participantId, rcsConsent });
    return response.data;
};
